var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeedflexTabLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4583 19.2159C17.5589 20.7046 17.7203 22.6751 16.8728 24.3196C16.0291 25.964 14.3195 27 12.4558 27H0.797038V22.8779H11.5937C11.5937 22.8779 11.9789 22.9178 12.5292 22.8779C12.5402 22.8779 12.5512 22.8779 12.5586 22.8779C12.7933 22.8489 13.0025 22.7113 13.1235 22.5085C13.2666 22.2803 13.2739 21.9905 13.1492 21.7514L12.676 21.2878L2.1214 10.8739L1.1639 9.93212C1.08686 9.85605 1.02082 9.77274 0.954788 9.68943C0.859404 9.55903 0.771358 9.42501 0.690649 9.28736C-0.167803 7.85659 -0.233838 6.0817 0.536568 4.5821C1.38401 2.93762 3.08991 1.90166 4.95723 1.90166H14.3488V0L21 4.00255L14.3488 8.00147V6.02737H4.95723C4.68208 6.02737 4.42895 6.16863 4.28587 6.40046C4.14647 6.63228 4.13546 6.91843 4.26019 7.1575L4.48765 7.38208L15.0422 17.7851L16.2455 18.9732C16.2822 19.0094 16.3152 19.0456 16.3519 19.0855C16.3886 19.1289 16.4253 19.1724 16.4546 19.2159H16.4583Z",
    fill: "#4650EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedflexTabLogo);
export default __webpack_public_path__ + "static/media/seedflexTabLogo.649008141d601cc5ebcb64254d0590a1.svg";
export { ForwardRef as ReactComponent };